goog.provide("shadow.js.shim.module$src$svg$artwork$cards_svg$default");
shadow.js.shim.module$src$svg$artwork$cards_svg$default = shadow.js.shim.module$src$svg$artwork$cards_svg.default;
